import { Typography } from "antd";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import eventBus from "src/common/eventBus";
import { Button } from "src/components";
import { 
  Form, 
  FormDatePicker, 
  FormNumber, 
  FormSelect, 
  FormText 
} from "src/components/Form";
import api from "src/config/api";

const EditBike = () => {
  const { id } = useParams();
  const [formData, setFormData] = useState();
  const navigate = useNavigate();
  
  useEffect(() => {
    const fetch = async () => {
      try {
        const response = await api.get(`bikes/${id}`);
        setFormData(response.data);
      } catch (error) {
        eventBus.emit("dialog", {
          type: "error",
          message: error.response?.data?.message || "Something went wrong",
        });
      }
    };
    fetch();
  }, [id]);

  const handleSubmit = async (data) => {
    try {
      await api.put(`bikes/${id}`, data);
      eventBus.emit("dialog", {
        type: "success",
        message: "Bike updated successfully!",
      });
      setTimeout(() => {
        navigate("/bikes");
        eventBus.emit("dialog", {
          open: false,
        });
      }, 2000);
    } catch (error) {
      eventBus.emit("dialog", {
        type: "error",
        message: error.response?.data?.message || "Something went wrong",
      });
    }
  };
  
  return (
    <>
      <Typography.Title level={4} className="mb-4">
        Edit Bike
      </Typography.Title>
      {formData && (
        <Form onSubmit={handleSubmit} layout="horizontal" defaultValues={formData}>
          <FormText
            label="Bike Name"
            placeholder="Bike Name"
            name="bikeName"
            required
          />
          <FormText
            label="License Number"
            placeholder="License Number"
            name="licenseNumber"
          />
          <FormText
            label="Owner"
            placeholder="Owner"
            name="owner"
          />
          <FormNumber 
            label="Purchase Price" 
            placeholder="Purchase Price" 
            name="purchasePrice" 
          />
          <FormNumber 
            label="Profit" 
            placeholder="Profit" 
            name="profit" 
          />
          <FormDatePicker
            label="Last Oil Change"
            placeholder="Last Oil Change"
            name="lastOilChange"
          />
          <FormText
            label="Insurance"
            placeholder="Insurance"
            name="insurance"
          />
          <FormNumber
            label="Kilometers Run"
            placeholder="Kilometers Run"
            name="kilometersRun"
          />
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form>
      )}
    </>
  );
};

export default EditBike; 